import React, {useEffect, useState} from 'react';
import TextBox from '../components/textbox'
import ButtonComp from '../components/button'
import '../styling/containerStyles.css'
import Label from '../components/label'
import Button from '@material-ui/core/Button';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';


interface VerifyOtpProps{
    handleToUpdateOtp:Function;
    msg:string;
}

export const VerifyOtp: React.FC<VerifyOtpProps> = (props: VerifyOtpProps) =>{

    const{
        handleToUpdateOtp, msg
    } = props;

    const [otp, setOtp] = useState('')
    const [message, setMessage] = useState(msg)

    const handleToUpdateContent = (name:string, arg:string) => {       
        setMessage("");
        if(name === 'otp'){
            setOtp(arg)
        }                
    }

    useEffect(() => {
        setMessage(msg);
    }, [msg]);

    const handleToUpdateOTP = (arg:string) => {
        var re = /^[0-9]{4}$/;
        if(re.test(otp) )
            handleToUpdateOtp(otp)
        else{
            setMessage('Please enter a valid OTP')
            setOtp('')
        }
        
    }

        return (
            <div className='home'>
                
                <div className='verifyNumberPage'>                  

                    <div className='buttonAndLabel'>
                        <Button className='goBack' onClick={() => {handleToUpdateOtp('GoBack')}} ><ArrowBackIosIcon /></Button> 
                        <Label content='Verify OTP' />
                    </div>
                    <br></br>
                    <div className='verifyOTP'>

                        <TextBox className='textBox'
                                label={'Enter OTP'} 
                                state={'otp'}
                                placeholder={'Eg: 1234'} 
                                handleToUpdate={handleToUpdateContent} 
                                 />
                                 
                        <div className='message'>{message}</div>

                        <ButtonComp label= {'Enter OTP'} 
                                name={'VERIFY OTP'} 
                                visible={true}
                                handleToUpdate={handleToUpdateOTP}  />
                    </div>

                </div>   

            </div>             
        )
    }

export default VerifyOtp